import styled from "styled-components";

export const Container = styled.div`
  margin-right: 4rem;

  & > div :not(:first-of-type) {
    margin-top: 0.8rem;
  }
`;

interface IItem {
  active?: any;
}
export const Item = styled.div<IItem>`
  ${({ active, theme }) => {
    const bgColor = active ? theme.colors.primaryBlue : theme.colors.white;
    const color = active ? theme.colors.white : theme.colors.gray;
    return `
      background-color: ${bgColor};
      color: ${color};
    `;
  }};

  align-items: center;
  border-radius: 0.8rem;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  font-size: 1.3rem;
  height: 5rem;
  justify-content: space-between;
  padding: 1.3rem 1.6rem;
  width: 25.6rem;
  margin-bottom: 0.5rem;
`;
